import clsx from "clsx";
import React from "react";
import { MENU_ACTIONS } from "../../common/components/modals/constants";
import useModal from "../../common/components/modals/useModal";
import { ActionsMenuButton } from "../actions/ActionsMenuButton";
import { SupportLink } from "../header/SupportLink";
import { ClearSearch } from "../components/ClearSearch";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { searchTitleType, supportLinkType } from "../../common/types/search/search";
import { actionsButtonDependsOnType } from "../../common/types/common";

interface ResultsHeaderProps {
	actionsButtonDependsOn?: actionsButtonDependsOnType;
	hasAdditionalSearch: boolean;
	namespace: string;
	onClearSearch: React.MouseEventHandler<HTMLButtonElement>;
	pagination?: React.ReactNode;
	resultsPreview: React.ReactNode;
	searchTitle: searchTitleType;
	supportLink?: supportLinkType;
}

export function ResultsHeader({
	actionsButtonDependsOn,
	hasAdditionalSearch,
	namespace,
	onClearSearch,
	pagination,
	resultsPreview,
	searchTitle,
	supportLink,
}: ResultsHeaderProps) {
	const { onOpenModal } = useModal();
	const { isMobile } = useAccessWindowSize();

	return (
		<header
			className={clsx("search-header", {
				"header-additional-search": hasAdditionalSearch,
			})}
		>
			<div className="results-count">
				<h1 className="h5" id="searchTitle">
					{searchTitle}
				</h1>
				{resultsPreview}
			</div>

			{hasAdditionalSearch && !isMobile && (
				<div className="btn-group">
					<SupportLink supportLink={supportLink} />

					<ClearSearch
						onClearSearch={onClearSearch}
						namespace={namespace}
					/>
				</div>
			)}

			{pagination}

			<ActionsMenuButton
				actionsButtonDependsOn={actionsButtonDependsOn}
				onClick={() => onOpenModal(MENU_ACTIONS)}
			/>
		</header>
	);
}
